<div class="progress-container">
  <div class="progress-details">
    <div class="top-row">
      <div class="pills">
        <div class="lane" *ngIf="!inColumn">
          <span class="inner">{{ lane }}</span>
        </div>
        <div class="priority-pill" [class]="'p' + priority" *ngIf="priority">
          <div class="icon">
            <mat-icon>flag</mat-icon>
            <span>{{ priorityText }}</span>
          </div>
        </div>
      </div>
      <span class="level" *ngIf="score">Score {{ score }}</span>
    </div>
    <div class="date-row">
      <span class="date-info">
        <span class="date-desktop"><b>{{ dueDate | firebaseDate | date: 'dd MMM yyyy' }}</b><br>{{ displayDaysLeft }}</span>
        <span class="date-mobile"><b>{{ dueDate | firebaseDate | date: 'dd MMM yyyy' }}</b> - {{ displayDaysLeft }}</span>
      </span>
    </div>
  </div>
  <div class="progress-bar">
    <div class="progress" [class.late]="daysLeft < 0" [style.width.%]="progress"></div>
  </div>
</div>